import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit{
  title = 'parohia';
  public isCollapsed:boolean=true;
  @ViewChild('videoStadiuLucrari')video!:ElementRef<HTMLVideoElement>;

  //////

  currentPhoto:number=1;
  currentProiectPhotoIndex:number=0;
  maxPhoto:number=10;
  currentPhoto2:number=1;
  maxPhoto2:number=12;

  //////
  
  proiectPhotos=['proiect1','proiect2','proiect3','proiect4','proiect5','santier1','santier2','santier3'];
  stopAutoRoll:boolean=false;
  chapter='primapagina';
  pdfSrc = './assets/Formular/Formular_anaf_pt_anul_2025.pdf';
  despreText="Parohia Pantelimon II. Anul 2026."+
  "Site realizat în Angular și Bootstrap.\n\r"+
  "Mulțumiri: \n\r"+
  "@vadimdez pentru ng2-pdf-viewer(licență MIT) "+
  "(https://www.npmjs.com/package/ng2-pdf-viewer).\n\r"+
  "wirestock on Freepik pentru imaginea de fundal"+
  "(https://www.freepik.com/free-photo/low-angle-shot-church-savior-blood-s-interior-st-petersburg-russia_9282972.htm#fromView=search&page=1&position=3&uuid=b5e984d4-fc45-4f89-8b03-e29049042554&query=Background+orthodox/)\n\r"+
  /*"jplenio pentru imaginea de fundal (Pixabay License)"+
  "(https://pixabay.com/photos/meadow-morgentau-nature-dew-water-3743023/)\n\r"+*/
  "ng-bootstrap(licență MIT) "+
  "(https://www.npmjs.com/package/@ng-bootstrap/ng-bootstrap)";
  

  ngAfterViewInit(){
    this.video.nativeElement.volume=0.10;
  }
  constructor(){
    /*
    timer takes a second argument, how often to emit subsequent values
    in this case we will emit first value after 1 second and subsequent
    values every 2 seconds after
  */
    const source = timer(1000, 10000);
    const subscribe = source.subscribe(val => {
      //Prima galerie photo
      if(!this.stopAutoRoll){
        if(this.currentPhoto==this.maxPhoto){
          this.currentPhoto=1;
        }else{
          this.currentPhoto++;
        }
      }
      //A doua galerie foto, cea cu proiectul+santierul
      if(this.currentProiectPhotoIndex==7){
        this.currentProiectPhotoIndex=0;
      }
      else{
        this.currentProiectPhotoIndex++;
      }
    });
  }
  despreSite(){
    alert(this.despreText);
  }
  galleryLeft(){
    this.stopAutoRoll=true;
    if(this.currentPhoto==1){
      this.currentPhoto=this.maxPhoto;
    }else{
      this.currentPhoto--;
    }
  }

  galleryRight(){
    this.stopAutoRoll=true;
    if(this.currentPhoto==this.maxPhoto){
      this.currentPhoto=1;
    }else{
      this.currentPhoto++;
    }
  }
  galleryLeft2(){
    if(this.currentPhoto2==1){
      this.currentPhoto2=this.maxPhoto2;
    }else{
      this.currentPhoto2--;
    }
  }

  galleryRight2(){
    if(this.currentPhoto2==this.maxPhoto2){
      this.currentPhoto2=1;
    }else{
      this.currentPhoto2++;
    }
  }

  gallerySet2(value:number){
    this.currentPhoto2=value;
  }

  changeMenu(chapter){
    this.chapter=chapter;
    this.toggleIsCollaped();
  }
  toggleIsCollaped(){
    this.isCollapsed=!this.isCollapsed;
  }
  collapseMenu(){
    this.isCollapsed=true;
  }
}
